import ManageDHIS2Diagnostic from '@/views/consultations/en-cours/dhis2-diagnostics/manage-dhis2-diagnostic'
import store_dhis2 from "@/store/mods/consultations/dhis-diagnostics"
import $ from 'jquery'

export default {
    name: 'dhis-2-diagnostics',
    components: {
        ManageDHIS2Diagnostic
    },
    props: {
        consultation: Object,
        section_name: String,
        slug: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object,
        patient: Object
    },
    data() {
        return {
            diag_loading: true,
            diag_is_empty: false,

            group_id: 0,
            modal_toggler: 0,
            data_to_be_deleted: {},
            info_user: {},
            liste_dhis2_diagnostics: [],
            selected_grp_diagnosis: {},
            is_error: false,
            p_is_femme_enceinte: 0
        }
    },

    watch: {
        evolution_toggler() {
            this.userInfoSetter()
            this.getListeConsultationDHIS2Diagnostic()
            this.p_is_femme_enceinte = this.consultation.is_femme_enceinte
        }
    },

    computed: {

    },

    mounted() {
        this.userInfoSetter()
        this.p_is_femme_enceinte = this.consultation.is_femme_enceinte
        this.getListeConsultationDHIS2Diagnostic()
    },

    methods: {
        userInfoSetter() {
            this.info_user = {
                nom_medecin: this.user_info.user,
                titre: this.user_info.titre
            }
        },

        addDiagnostic() {
            this.group_id = 0
            this.modal_toggler =  (this.modal_toggler == 0)?1:0;
            this.selected_grp_diagnosis = {
                diagnostics: []
            }

            $('.dhis-diag-'+this.evolution_id+this.slug).modal('show')
        },

        getListeConsultationDHIS2Diagnostic() {
            this.diag_loading = true
            this.is_error = false
            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                data_type: 'dhis2_diagnostic',
                enCours: true
            }
            
            store_dhis2.getDHIS2Diagnostic(data).then((response) => {
                this.liste_dhis2_diagnostics = response;

                if (response.length === 0) {
                    this.diag_is_empty = true;
                } else {
                    this.diag_is_empty = false;
                }
                this.diag_loading = false;
            }).catch(() => {
                this.diag_loading = false;
                this.is_error = true;
            });
        },

        addToListDiagnostics(data) {
            this.group_id = data.diagnosis_group_id
            this.modal_toggler = (this.modal_toggler === 0)?1:0

            this.selected_grp_diagnosis = {
                diagnostics: data.list_diagnosis,
                is_femme_enceinte: data.is_femme_enceinte,
            }
            $('.dhis-diag-'+this.evolution_id+this.slug).modal('show')
        },

        removeDHIS2Diagnostic(data, group_id) {
            this.modal_toggler = (this.modal_toggler === 0)?1:0
            this.data_to_be_deleted = {
                diagnostic_id: data.id,
                diagnostic_uid: data.diagnostic_uid,
                libelle: data.diagnostic,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: group_id,
                data_type: 'dhis2_diagnostic',
                is_group_del: 0
            }
            $('.del-dhisdiag'+this.evolution_id+this.group_id).modal('show')
        },

        removeGroupDHIS2Diagnostic(group_diagnosis) {
            this.modal_toggler = (this.modal_toggler === 0)?1:0
            this.data_to_be_deleted = {
                libelle: group_diagnosis.reference,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: group_diagnosis.diagnosis_group_id,
                data_type: 'dhis2_diagnostic',
                is_group_del: 1
            }
            $('.del-dhisdiag'+this.evolution_id+this.group_id).modal('show')
        },
    }
}
